import { render, staticRenderFns } from "./CranesListPage.vue?vue&type=template&id=1f9b0b3c&"
import script from "./CranesListPage.vue?vue&type=script&lang=ts&"
export * from "./CranesListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports